import {
  Component,
  OnInit,
  ViewChild,
  Input,
  inject,
  DestroyRef,
  computed,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Services } from "src/app/services/api.service"
import { HelperFunctionsService } from 'src/app/services/helper-functions.service';
import { GlobalConstants } from 'src/app/common/global';
import { ActivatedRoute } from '@angular/router';
import { WebSocketService } from 'src/app/services/web-socket-service.service';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { UserCards } from 'src/app/common/interfaces';
import { GetSavedCardsService } from 'src/app/services/get-saved-cards.service';
import { OrderService } from 'src/app/services/getOrder.service';
import { CommonModule } from '@angular/common';
import { CreditCardComponent } from '../credit-card/credit-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ModalNames } from 'src/app/common/modal.config';
import { ModalService } from 'src/app/services/modal.service';
import { LanguageService } from "../../services/language.service";
import { allowedOrigins } from "../../common/constants";
import {CompanyInvoiceComponent} from "../company-invoice.ts/company-invoice.ts.component";

@Component({
  selector: 'app-payment',
  templateUrl: `${environment.pageFolder}/payment.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/payment.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, CreditCardComponent, ReactiveFormsModule, TranslateModule, CompanyInvoiceComponent]
})
export class PaymentComponent implements OnInit, OnDestroy {
  paymentForm:any = this.formBuilder.group({
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    address: "",
    city: "",
    pbr: "",
    country: "",
    drzava_iso: ""
  });
  @Input() hasPayment: any;
  @Input() orderInfo: any;
  @Input() customerProfile: any;
  @Input() orderId: any;
  @Input() cart: any;
  @Input() redirectUrlFromParent: string = "";
  @Input() redirectErrorUrlFromParent: string = "";
  @Output() goBackEvent = new EventEmitter<void>();
  @Output() paymentStarted = new EventEmitter<void>();
  connId = environment.connId;
  cardType: string = "";
  paymentInfo: any;
  showSavedCards: boolean = true;
  paymentIsDone: boolean = false;
  apiUrl: string = environment.apiUrl;
  paymentUrl = environment.paymentUrl;
  redirectUrl!: string;
  redirectUrlErr: string = environment.redirectUrl;
  paymentWays: any = [
    {
      name: "temp_nacpl",
      label: "Kartice"
    },
    {
      name: "kekspay",
      label: "Kekspay"
    },
    {
      name: "aircashpay",
      label: "Aircash"
    }
  ]
  countryList: any;
  country: any;
  errorMessage: any;
  loader = document.getElementById("loader-container");
  qrCode: string = "";
  qrLink: string = "";
  deviceType: string = "";
  remainingTimeToPay: number = 600;
  remainingTimeToPayFormatted: string = "";
  formattedTelephoneNumber: string | undefined;
  profileCountry: any;
  showPaymentIframe: boolean = false;
  wpId: string = "";
  saveCardForm: FormGroup;
  saveCardValue: number | null = null;
  appId: string = environment.appId;
  userCards: UserCards[] = [];
  userCardToken: string = "";
  userCardTokenNumber: string = "";
  paymentButtonIsClicked: boolean = false;
  showPaymentButtons: boolean = true;
  selectedCard: any;
  redirectPage: string = "";
  private countdownInterval: any;
  @ViewChild('pgw') pgw:any;
  public readonly modalNamesEnum = ModalNames;
  readonly isPaymentModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.Payment) ?? false);
  hidePaymentButtons: boolean = false;

  private readonly destroyRef = inject(DestroyRef);
  private readonly languageService = inject(LanguageService);
  readonly paymentLanguage = this.languageService.paymentLanguage;
  private messageCardHandler = this.onIframeMessage.bind(this);

  @ViewChild(CompanyInvoiceComponent) companyInvoiceComp!: CompanyInvoiceComponent;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    public Services: Services,
    private HelperFunctionsService: HelperFunctionsService,
    private webSocketService: WebSocketService,
    private userProfileService: GetUserProfileService,
    private getSavedCardsService: GetSavedCardsService,
    private orderService: OrderService,
    private route: ActivatedRoute,
    private readonly errorMessageService: ErrorMessageService,
    public modalService: ModalService
    ){
      this.loader!.style.display = "none";

      this.saveCardForm = this.formBuilder.group({
        saveCardYes: [false],
        saveCardNo: [false]
      });

      const routeParams = this.route.snapshot.queryParams["type"];
      let underAge = false;

      if(environment.configId === "4") {
        this.getCards();
      }

      setTimeout(() => {
        if(this.orderInfo && this.orderInfo.additionalItems) {
          this.orderInfo.additionalItems[1].description.includes("do 18g./od") && (underAge = true);
        }

        if((window.location.href.indexOf("buy-membership") > -1) && (routeParams === "full-fledged" || routeParams === "")) {
          if(underAge) {
            this.redirectUrl = environment.redirectUrl + `/membership-profile-others`;
          } else {
            this.redirectUrl = environment.redirectUrl + `/membership-profile`;
          }
        } else if(routeParams === "club-friend") {
          this.redirectUrl = environment.redirectUrl + `/club-friends-profile`;
        } else {
          this.redirectUrl = environment.redirectUrl + `/user-profile`;
        }
      }, 300);

      window.addEventListener('message', this.messageCardHandler, false);
    }

  ngOnInit(): void {
    if(this.customerProfile === undefined || this.customerProfile === null) {
      this.userProfileService.getConnectionUserProfile().subscribe({
        next: (data: any) => {
          this.customerProfile = data.data;
        }
      });
    }

    this.redirectPage = this.redirectUrlFromParent;
    this.redirectUrlFromParent && (this.redirectUrlFromParent = environment.redirectUrl + '/' + this.redirectUrlFromParent);
    this.redirectErrorUrlFromParent && (this.redirectErrorUrlFromParent = environment.redirectUrl + '/' + this.redirectErrorUrlFromParent);

    let orderInfoRemainingTimeToPayFromStorage: any = sessionStorage.getItem("orderInfoRemainingTimeToPay");
    let orderInfoRemainingTimeToPayFromStorageJson: any = JSON.parse(orderInfoRemainingTimeToPayFromStorage);

    if(orderInfoRemainingTimeToPayFromStorageJson !== null) {
      const timeNow = new Date();
      this.remainingTimeToPay = Math.round(600 - (timeNow.getTime() - orderInfoRemainingTimeToPayFromStorageJson) / 1000);
    }

    this.deviceType = this.HelperFunctionsService.checkIfUserIsOnMobile();
    this.userProfileService.getUserProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (userProfile) => {
        this.wpId = userProfile.id.toString();
      },
      error: () => {}
    });
  }

  onSubmitMonriCardForm() {
    if (this.companyInvoiceComp?.showCompanyInvoice) {
      if (this.companyInvoiceComp.isFormValid()) {
        this.companyInvoiceComp.onSubmitCompanyInvoice();
      } else {
        return;
      }
    }

    if(environment.configId === "4" && this.cardType === "temp_nacpl" && (this.redirectPage === 'user-profile' || this.redirectPage === 'group-tickets-profile')) {
      this.modalService.openModal(ModalNames.Payment);
    } else if(environment.configId === "4" && (this.redirectPage !== 'user-profile' && this.redirectPage !== 'group-tickets-profile')) {
      this.showPaymentButtons = false;
    }

    const formValues = this.saveCardForm.value;
    this.saveCardValue = formValues.saveCardYes ? 1 : (formValues.saveCardNo ? 0 : null);
    const payMethodId = "10";

    let body: object = {
      'cardHolderDetails': "",
      'payMethodId': payMethodId,
      'cardType': this.cardType === "saved-cards" ? "temp_nacpl" : this.cardType,
      'ip': '127.0.0.1',
      'deviceType': this.deviceType,
      'redirectUrl': this.redirectUrlFromParent || this.redirectUrl,
      'redirectUrlErr': this.redirectErrorUrlFromParent || this.redirectUrlErr
    }

    this.http.post(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/payment`, body, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        this.paymentInfo = response.data;
        this.paymentIsDone = true;
        sessionStorage.removeItem("removeData");

        setTimeout(() => {
          this.finishPayment();
        }, 500);
      },
      error: error => {
        if(error?.error?.errors[0]?.code === "ORA-20990" || error?.error?.errors[0]?.code === "ORA-20900") {
          window.location.reload();
        }

        if(error.status === 401) {
          this.Services.logout();
        }
      }
    })
  }

  getCards() {
    this.getSavedCardsService.getSavedCards(false).subscribe((Response: any) => {
      this.userCards = Response.data;
    })
  }

  selectUserCard(card: UserCards) {
    if (this.userCardToken === card.token) {
      this.userCardToken = "";
      this.userCardTokenNumber = "";
      this.selectedCard = null;
    } else {
      this.userCardToken = card.token;
      this.userCardTokenNumber = card.tokenNumber;
      this.selectedCard = card;
    }

    if(environment.configId === "4") {
      this.onSubmitMonriCardForm();
    }
  }

  onSubmit() {
    let hasError: boolean;
    this.paymentStarted.emit();

    if(this.cardType !== "kekspay" && this.cardType !== "aircashpay") {
      hasError = this.userFormValidation();
    } else {
      hasError = false;
    }

    if (this.companyInvoiceComp?.showCompanyInvoice) {
      if (this.companyInvoiceComp.isFormValid()) {
        this.companyInvoiceComp.onSubmitCompanyInvoice();
      } else {
        return;
      }
    }

    if(environment.configId === "4") {
      this.paymentButtonIsClicked = true;
      if(this.redirectPage === 'user-profile' || this.redirectPage === 'group-tickets-profile') {
        this.modalService.openModal(ModalNames.Payment);
      } else {
        this.showPaymentButtons = false;
      }
    }

    if(hasError === false) {
      this.errorMessage = "";
      this.loader!.style.display = "flex";
      let payMethodId = "10";

      this.deviceType = this.HelperFunctionsService.checkIfUserIsOnMobile();

      let firstNameCardHolder: string, lastNameCardHolder: string;
      if(this.cardType === "kekspay" || this.cardType === "aircashpay") {
        firstNameCardHolder = this.customerProfile.firstName;
        lastNameCardHolder = this.customerProfile.lastName;
      } else {
        firstNameCardHolder = this.paymentForm.value.firstName;
        lastNameCardHolder = this.paymentForm.value.lastName;
      }

      let body: object = {
        'cardHolderDetails': `ime:${firstNameCardHolder}||prezime:${lastNameCardHolder}||adresa:${this.paymentForm.value.address}||kucni_broj:||pbr:${this.paymentForm.value.pbr}||mjesto:${this.paymentForm.value.city}||email:${this.paymentForm.value.email}||tel:${this.formattedTelephoneNumber}||drzava:${this.paymentForm.value.country}||`,
        'payMethodId': payMethodId,
        'cardType': this.cardType,
        'ip': '127.0.0.1',
        'deviceType': this.deviceType,
        'redirectUrl': this.redirectUrlFromParent || this.redirectUrl,
        'redirectUrlErr': this.redirectErrorUrlFromParent || this.redirectUrlErr
      }

      this.http.post(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/payment`, body, GlobalConstants.headersCentral).subscribe({
        next: data => {
          let response:any = data;
          this.paymentInfo = response.data;
          this.paymentIsDone = true;
          sessionStorage.removeItem("removeData");

          let paymentUrl: string, paymentUrlError: string;
          if(this.cardType === "kekspay" || this.cardType === "aircashpay") {
            paymentUrl = this.redirectUrlFromParent || this.redirectUrl;
            paymentUrlError = this.redirectErrorUrlFromParent || environment.redirectUrl;
          } else {
            paymentUrl = this.redirectUrlFromParent || `${environment.paymentUrl}/${environment.urlSuffix}/`;
            paymentUrlError = this.redirectErrorUrlFromParent || environment.redirectUrl;;
          }

          if(this.cardType === "kekspay" || this.cardType === "aircashpay") {
            let bodyQr: object = {
              "iznos": this.paymentInfo.iznos,
              "opis": this.paymentInfo.opis,
              "sifpl": this.paymentInfo.sifpl,
              "valuta": this.paymentInfo.valuta,
              "hash": this.paymentInfo.hash,
              "redirectUrl": paymentUrl,
              "redirectUrlErr": paymentUrlError,
              "notifyUrl": `${environment.apiUrl}/v1/private/order/${environment.connId}/${this.orderId}/finish`
            }

            this.http.post(`${environment.apiUrl}/v1/public/order/${environment.connId}/${this.orderId}/qr`, bodyQr, GlobalConstants.headersCentral).subscribe({
              next: data => {
                let response:any = data;
                let responseData = response.data;
                let user = `WEB_PGW_${environment.connId}-${this.orderId}`;
                let wsUrl = environment.webSocketUrl;
                this.startCountdown();
                this.qrCode = "data:application/pdf;base64," + responseData.qrcode;
                if(this.cardType === "kekspay") this.qrLink = `https://kekspay.hr/pay?qr_type=1&tid=${responseData.tid}&cid=${responseData.cid}&store=${responseData.store}&bill_id=${responseData.billId}&amount=${responseData.amount}&success_url=${this.redirectUrl}&fail_url=${environment.redirectUrl}`;
                else this.qrLink = responseData.acredirecturl;
                this.loader!.style.display = "none";

                const now = new Date();
                const timestamp = now.getTime();

                let orderInfo = {
                  orderId: this.orderId,
                  remainingTimeToPay: timestamp,
                }

                if(!sessionStorage.getItem('orderInfoRemainingTimeToPay')) {
                  const now = new Date();
                  const timestamp = now.getTime();
                  sessionStorage.setItem('orderInfoRemainingTimeToPay', JSON.stringify(timestamp));
                }

                localStorage.setItem('orderInfo', JSON.stringify(orderInfo));

                this.webSocketService.connect(user, wsUrl, this.redirectUrlFromParent || this.redirectUrl);

                if(environment.configId === "4" && this.deviceType === 'M' && this.qrLink) {
                  this.openApplication()
                }
              },
              error: error => {
                this.loader!.style.display = "none";
                this.errorMessage = this.errorMessageService.getErrorMessage('error');
              }
            })
          } else {
            setTimeout(() => {
              this.finishPayment();
            }, 500);
          }
        },
        error: error => {
          if(error?.error?.errors[0]?.code === "ORA-20990" || error?.error?.errors[0]?.code === "ORA-20900") {
            window.location.reload();
          }

          if(error.status === 401) {
            this.Services.logout();
          }

          if(error.status === 500) {
            this.loader!.style.display = "none";
            this.errorMessage = this.errorMessageService.getErrorMessage('error');
            setTimeout(() => {
              //this.router.navigate([`${environment.redirectUrl}`]);
            }, 3000);
          }
        }
      })
    }
  }

  openApplication() {
    document.location = this.qrLink;
  }

  userFormValidation() {
    let inputs = document.querySelectorAll('[data-name="payment-form-input"]');
    let error = false;

    inputs.forEach((item:any) => {
      if(!item.value) {
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.backgroundColor = "#ed0000";
        error = true;
        this.errorMessage = this.errorMessageService.getErrorMessage('allFieldsRequired');
      }
    })

    return error;
  }

  changeCountry(event:any) {
    this.country = event.target.value;
    let isoNumCode = "";
    this.countryList?.forEach((item: any) => {
      if (this.country === item.name) {
        isoNumCode = item.isoNumCode;
      }
    });

    this.paymentForm.patchValue({
      drzava_iso: isoNumCode,
      country: this.country
    });
  }

  finishPayment() {
    this.paymentStarted.emit();
    this.loader!.style.display = "flex";

    this.orderService.getOrder(this.orderId, true).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        let pgwForm = (document.getElementById("pgw") as HTMLFormElement);
        if(this.cardType === "temp_nacpl" || this.cardType === "saved-cards") {
          let paymentIframe = document.getElementById("paymentIframe") as HTMLFormElement;

          paymentIframe.style.display = "block";
          this.showPaymentIframe = true;
        }

        if(this.cardType === "saved-cards") {
          this.showSavedCards = false;
        }

        pgwForm?.submit();
        this.paymentIsDone = false;
        this.loader!.style.display = "none";
      },
      error: (error) => {
        if (error.status === 401) {
          this.Services.logout();
        }
      }
    });
  }

  openSavedCardsModal() {
    this.cardType = "saved-cards";
    this.showSavedCards = true;

    (this.redirectPage === 'user-profile' || this.redirectPage === 'group-tickets-profile') && this.modalService.openModal(ModalNames.Payment);
  }

  selectCardTypeForPayment(cardType:string) {
    this.cardType = cardType;
    this.showPaymentButtons = true;
    this.paymentButtonIsClicked = false;

    if(cardType === "saved-cards") {
      this.hidePaymentButtons = true;
    } else {
      this.hidePaymentButtons = false;
    }

    if(cardType === "temp_nacpl" && environment.configId !== "4") {
      this.getCards();
    } else if(cardType === "temp_nacpl" ) {
      this.userCardToken = "";
      this.userCardTokenNumber = "";
      this.selectedCard = null;
    }
  }

  selectCardType(cardType:string) {
    if(cardType !== "aircashpay" && cardType !== "kekspay") {
      this.loader!.style.display = "flex";
      this.getCards();
      this.profileCountry = this.customerProfile.country;
      this.country = this.profileCountry;
      (this.country === "HR" || this.country === null) && (this.country = "Hrvatska");

      this.paymentForm.patchValue({
        firstName: this.customerProfile.firstName,
        lastName: this.customerProfile.lastName,
        email: this.customerProfile.email,
        telephone: this.customerProfile.phone,
        address: this.customerProfile.address,
        city: this.customerProfile.city,
        pbr: this.customerProfile.postCode,
        country: this.country
      });

      let isoNumCode = "";

      this.paymentForm.patchValue({ drzava_iso: isoNumCode });
      this.loader!.style.display = "none";
      this.cardType = cardType;
    } else if (cardType === "aircashpay" || cardType === "kekspay") {
      this.cardType = cardType;
      this.finishPayment();
      this.onSubmit();
    }
  }

  startCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    this.countdownInterval = setInterval(() => {
      this.remainingTimeToPay--;
      const minutes = Math.floor(this.remainingTimeToPay / 60);
      const seconds = this.remainingTimeToPay - minutes * 60;
      const formattedMinutes = minutes.toString().padStart(2, '0');
      const formattedSeconds = seconds.toString().padStart(2, '0');
      this.remainingTimeToPayFormatted = `${formattedMinutes}:${formattedSeconds}`;

      if (this.remainingTimeToPay <= 0) {
        clearInterval(this.countdownInterval);
        sessionStorage.removeItem("orderInfoRemainingTimeToPay");
        window.localStorage.removeItem('orderIdEventId');
        window.localStorage.removeItem('orderId');
        this.Services.cancelOrder( this.orderId, false, {changeUrl: false, url: ""});
      }
    }, 1000);
  }

  cancelOrder() {
    this.Services.cancelOrder( this.orderId, false, {changeUrl: false, url: ""});
  }

  goBack() {
    this.goBackEvent.emit();
  }

  private onIframeMessage(event: MessageEvent) {
    if (!allowedOrigins.has(event.origin)) {
      console.warn('Blocked postMessage from unknown origin:', event.origin);
      return;
    }

    const { redirectUrl } = (event.data ?? {}) as { redirectUrl?: string };
    if (typeof redirectUrl === 'string') {
      window.location.replace(redirectUrl);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.messageCardHandler, false);
  }
}
